import { useTheme } from '@mui/material';
import { IStep, IWork, SkeletonsLC, useNavbarStore, WorkLayoutRenderingMode } from '@diana/core';
import { WorkPageLayout } from './WorkPageLayout';
import useMediaQuery from '@mui/material/useMediaQuery';

export interface IWorkPageContentProps {
  work?: IWork;
  isLoading?: boolean;
  workErrorCode?: string;
  renderingMode?: WorkLayoutRenderingMode;
  onTaskChange?: (task: IStep) => void;
}

export function WorkPageContent(props: IWorkPageContentProps) {
  const { work, isLoading, renderingMode, onTaskChange } = props;
  const { breakpoints } = useTheme();
  const navbarMobileBreakpoint = useNavbarStore((s) => s.getMobileBreakpoint());
  const isSmallDevice = useMediaQuery(breakpoints.down(navbarMobileBreakpoint));

  if (isLoading) return <SkeletonsLC boxPadding={0} />;
  return (
    <WorkPageLayout
      work={work}
      isSmallDevice={isSmallDevice}
      renderingMode={renderingMode}
      onPageChange={onTaskChange}
    />
  );
}
